module.exports = __webpack_public_path__ + "img/checkbox_off.96293201.svg";